'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIModal from 'UIComponents/dialog/UIModal';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import { languageI18nKey } from 'DesignComponents/utils/I18nKeys';
import H2 from 'UIComponents/elements/headings/H2';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
export default class DeleteLanguageModal extends Component {
  render() {
    const {
      i18nKey,
      languageToDelete,
      onDeleteLanguage,
      onDeleteLanguageCancel,
      disabled
    } = this.props;
    return /*#__PURE__*/_jsxs(UIModal, {
      use: "danger",
      children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
        children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
          onClick: onDeleteLanguageCancel
        }), /*#__PURE__*/_jsx(H2, {
          children: /*#__PURE__*/_jsx(FormattedReactMessage, {
            message: i18nKey('deleteLanguageModal.header'),
            options: {
              language: /*#__PURE__*/_jsx(FormattedMessage, {
                message: languageI18nKey(languageToDelete)
              })
            }
          })
        })]
      }), /*#__PURE__*/_jsx(UIDialogBody, {
        children: /*#__PURE__*/_jsx("span", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey('deleteLanguageModal.body')
          })
        })
      }), /*#__PURE__*/_jsxs(UIDialogFooter, {
        children: [/*#__PURE__*/_jsx(UIButton, {
          use: "danger",
          onClick: onDeleteLanguage,
          disabled: disabled,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey('deleteLanguageModal.buttons.delete')
          })
        }), /*#__PURE__*/_jsx(UIButton, {
          use: "tertiary-light",
          onClick: onDeleteLanguageCancel,
          disabled: disabled,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey('deleteLanguageModal.buttons.cancel')
          })
        })]
      })]
    });
  }

}
DeleteLanguageModal.propTypes = {
  languageToDelete: PropTypes.string,
  i18nKey: PropTypes.func.isRequired,
  onDeleteLanguage: PropTypes.func.isRequired,
  onDeleteLanguageCancel: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};